import { MdAdd, MdEdit } from 'react-icons/md'
import { Link } from 'react-router-dom'
import ButtonDeleteMineralCountry from './ButtonDeleteMineralCountry'

export default function ModalMineralCountriesListItem({
  country,
  mineralId,
  fetchCountries,
}) {
  if (country.id === 22) {
    return (
      <div className="flex items-center justify-between border-2 border-muted-500 p-2">
        <div className="line-clamp-1 pr-2">لم يتم اكتشافه بعد في المنطقة.</div>
        <div>
          <Link
            to={`/minerals/${mineralId}/countries/${country.id}/edit`}
            className="flex border-2 border-primary-500 bg-primary-300 p-1 text-white hover:bg-primary-500"
          >
            <MdEdit size={22} />
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="flex items-center justify-between border-2 border-muted-500 p-2">
      <div className="flex w-full items-center gap-4">
        <img
          src={`${process.env.REACT_APP_API_BASE_URL}/storage/flags/${country?.image}`}
          alt={country.name_ar}
          title={country.name_ar}
          className={`w-14 border-2 border-muted-700`}
        />
        <div
          title={country.name_ar}
          className="line-clamp-1"
        >
          {country.name_ar}
        </div>
      </div>
      <div className="flex gap-2">
        {country?.has_mineral ? (
          <>
            <Link
              to={`/minerals/${mineralId}/countries/${country.id}/edit`}
              className="flex border-2 border-primary-500 bg-primary-300 p-1 text-white hover:bg-primary-500"
            >
              <MdEdit size={22} />
            </Link>
            <ButtonDeleteMineralCountry
              mineralId={mineralId}
              countryId={country.id}
              fetchCountries={fetchCountries}
            />
          </>
        ) : (
          <Link
            to={`/minerals/${mineralId}/countries/${country.id}/create`}
            className="flex border-2 border-success-500 bg-success-300 p-1 text-white hover:bg-success-500"
          >
            <MdAdd size={22} />
          </Link>
        )}
      </div>
    </div>
  )
}
